import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=3185424c&scoped=true&"
import script from "./page6.vue?vue&type=script&lang=js&"
export * from "./page6.vue?vue&type=script&lang=js&"
import style0 from "./page6.vue?vue&type=style&index=0&id=3185424c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185424c",
  null
  
)

export default component.exports